import img from '../../helpers/img';

export default {
  title: 'Scrap & Haul',
  tile: {
    grid: 'col-12 lap-3',
    bgImage: img('scrap-and-haul/sh-landing.jpg')
  },
  hero: {
    bgImage: img('scrap-and-haul/sh-landing.jpg'),
    bgPosition: 'top'
  },
  info: {
    client: 'Scrap & Haul',
    timeline: '2013 - 2014',
    description: [
      'Scrap & Haul is a Bay Area junk hauling specialist, that contracted me for a corporate rebranding.',
      'I provided:',
      '::a new logo',
      '::a new website',
      '::a custom back end'
    ],
    tools: `
      HTML,
      SASS,
      JS,
      Handlebars,
      Grunt,
      Photoshop,
      Illustrator
    `,
    buttons: [{
      text: 'VIEW WEBSITE',
      url: 'https://scrap-and-haul-production.herokuapp.com/'
    }]
  },
  assets: [
    {
      grid: 'col-12 lap-6 desk-12',
      thumb: img('scrap-and-haul/sh-landing.jpg'),
      caption: 'Scrap & Haul Landing Page'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('scrap-and-haul/sh-pricing.jpg'),
      caption: 'Scrap & Haul Pricing'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('scrap-and-haul/sh-overview.jpg'),
      caption: 'Scrap & Haul Overview'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('scrap-and-haul/sh-booking.jpg'),
      caption: 'Scrap & Haul Booking'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/fixtures/projects/scrapAndHaul.js